module.exports = __webpack_public_path__ + "img/orange_029.6a015c05.png";